define(function (require) {

	const tpl = require('./templates/t_itv_add_detail.hbs');
	const DetailPageModel = require('civicsModels/core/detail_page_model');
	const DetailObjectModel = require('civicsModels/core/detail_object_model');
	const ViewManager = require('civicsUtils/view_manager');
	const ViewBindingManager = require('civicsUtils/view_binding_manager');
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const DetailViewBase = require('./v_itv_detail_base');
	const ModalDetails = require('./modal_view/v_lov_modal_detail.js');

	return DetailViewBase.extend({
		template: tpl,
		FILTERCODEMODELID: '',
		onRender: function () {

			// if (this.agencyDataReady) {
			// 	if (this.isGrid) {
			// 		//if this is a grid, pass the entire collection so the view binding manager knows how to project the binds.
			// 		ViewBindingManager.bindView(this, this.m);
			// 	}
			// 	else {
			// 		ViewBindingManager.bindView(this, this.m.models[0]);
			// 	}
			// }
			// this.ui.dates.each(function (index, el) {
			// 	var date = $(this).val();
			// 	$(this).val(Handlebars.helpers['global:formatDate'](date));
			// });
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			//AutoComplete
			var moniker;
			if ( this.mDetailPage ) moniker = this.mDetailPage.get('detailPage.childMoniker');
			if (moniker) {
				ViewManager.setupAutoComplete(this,moniker);
				this.FILTERCODEMODELID = moniker;
				this.setupFilterCodes(moniker, true, true);
			}


			ViewManager.resetErrorMessages(this);
		},
		onValidate: function () {
			var valid = ViewManager.validatePageControl(this, true);//pass in true to force validation by IDs
			if (!valid) this.triggerMethod('invalid');
		},
		templateHelpers: function () {
			var content = '';
			var childMoniker = '';
			if (this.mDetailPage) {
				content = this.mDetailPage.get('document');
				if (content && content.get) {
					content = content.toJSON();
				}
				childMoniker = this.mDetailPage.get('detailPage.childMoniker');
			}
			return {
				doc: content,
				enabled: this.enabled,
				hasFields: this.hasFields === false ? false : true,
				toggleEnabled: this.toggleEnabled,
				detailOptions: {
					isGrid: this.isGrid,
					isAdd:this.isAdd
				},
				isExpanded: this.defaultExpanded,
				childMoniker: childMoniker,
			};
		},
	});
});
